<template>
  <div v-show="tableDisplay == 'routes_assigned'">
    <v-row style="margin-top: -83px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details>
          <template slot="append-outer">
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="selected.length > 0">
        <v-app-bar color="grey darken-3" dense dark>
          <v-toolbar-title class="overline"
            >{{ selected.length }} selected</v-toolbar-title
          >
          <v-divider class="mx-4" vertical></v-divider>
          <v-btn
            depressed
            class="overline mx-4 custom-hover"
            color="grey darken-3"
            @click="seeTransactionLog()"
            >Route Tracking Details</v-btn
          >
        </v-app-bar>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-data-table
          show-select
          v-model="selected"
          :single-select="false"
          :items="getAssignedSubRoutes"
          :headers="headers"
          :items-per-page="5"
          class="elevation-2"
          item-key="id"
          :search="search"
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.route.subject`]="{ item }">
            <a class="goto" :href="item.link">
              {{ item.route.subject }}
            </a>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              pill
              color="yellow darken-3"
              text-color="white"
              v-if="item.warningStatus && item.status != 'Done' && item.overdue_status != true"
            >
              {{ item.status }}
            </v-chip>
            <v-chip
              small
              pill
              color="green darken-1"
              text-color="white"
              v-else-if="item.status == 'Done'"
            >
              {{ item.status }}
            </v-chip>
            <v-chip
              v-else-if="item.overdue_status"
              small
              pill
              color="red darken-1"
              text-color="white"
            >
              {{ item.status }}
            </v-chip>
            <v-chip
              v-else-if="item.status == 'Pending'"
              small
              pill
              color="grey"
              text-color="white"
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:[`item.overdue_status`]="{ item }">
            <v-icon :color=" item.overdue_status ? 'red' : ''">mdi-circle</v-icon>
          </template>
          <template v-slot:[`item.durations`]={item}>
            <DateCountdown
              :routeId="item.id"
              :routeType="'subroute'"
              :date="item.durations"
              :isWarned="item.isWarned"
              :accessRoutesList="'list'"
              :showCaption="false"
              :currentStatus="computedOverdueStatusColor"
              :showDate="false"
              :onlyHeader="false"
              :isOverdued="item.overdue_status"
              @emitWarning="routeWarning"
            />

          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      class="pb-10"
    >
      This action requires you to select only one route

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DateCountdown from '../DateCountdown';

export default {
  name: "RoutesAssignedTable",
  components: {
    DateCountdown
  },
  props: {
    tableDisplay: String,
    // search: String,
    isFetching: Boolean
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Subject", align: "start", sortable: true, value: "route.subject" },
        { text: "Initiator", value: "initiator" },
        { text: "Status", value: "status" },
        { text: "Overdue Status", value: "overdue_status", align: "center" },
        { text: "Due Date", value: "durations" },
        { text: "Route Urgency", value: "urgency" },
      ],
      overdue_status_color: '',
      selected: [],
      snackbar: false,
      timeout: 5000,
    }
  },
  computed: {
    ...mapGetters(["getAssignedSubRoutes"]),
    computedOverdueStatusColor: function(item) {
      return item.overdue_status ? "red" : item.isWarned ? 'yellow lighten-4': '';
    }
  },
  methods: {
    getColor(status) {
      if(status == 'Pending') {
        return;
      } else if(status == 'Overdue') {
        return "red"
      } else if(status == "Done") {
        return "green";
      } else {
        return;
      }
    },
    routeWarning(val) {
      if(val) this.overdue_status_color = "yellow lighten-4";
    },
    seeTransactionLog() {
      if(this.selected.length > 1) {
        this.snackbar = true;
      } else {
        this.selected_log_id = this.selected[0].id;
        this.route_log_dialog = true;
      }
    },
  }
};
</script>

<style>
</style>